<template>
  <v-flex class="enface-image-wrapper" id="enface-image-wrapper">
    <image-not-found v-if="enfaceImgNotFound" />
    <canvas-image :canvasSize="enfaceFit" :imgSize="enfaceFit" :img="enfaceImg"/>
    <canvas-annotation v-if="showETDRS" 
      :canvasSize="enfaceFit"
      :annotation="etdrs"/>
    <v-progress-circular v-if="isLoading" class="escalon-absolute-center" indeterminate/>
  </v-flex>
</template>

<script>
import { mapGetters } from "vuex";
import canvasImage from "../../../canvas/components/CanvasImage";
import canvasAnnotation from "../../../canvas/components/CanvasAnnotation";
import AnalysisETDRS from "../../../canvas/annotations/analysisETDRS";
import imageNotFound from "../../misc/ImageNotFound";
export default {
  name: "enfaceView",
  components: { canvasImage, canvasAnnotation, imageNotFound },
  props: ["enfaceFit", "enfaceImgSize"],
  data() {
    return {
      etdrs: new AnalysisETDRS()
    };
  },
  computed: {
    ...mapGetters([ "octDataLoading", "enfaceImg", "enfaceImgNotFound", "enfaceImgLoading", "foveaOffset", 
    "thicknessAnalysis", "showETDRS" ]),
    isLoading() {
      return this.enfaceImgLoading || this.octDataLoading;
    }
  },
  watch: {
    foveaOffset() {
      this.etdrs.updateFoveaOffset(this.foveaOffset);
    },
    thicknessAnalysis() {
      this.etdrs.updateThicknessAnalysis(this.thicknessAnalysis);
    }
  },
  mounted() {
    this.etdrs.updateFoveaOffset(this.foveaOffset);
    this.etdrs.updateThicknessAnalysis(this.thicknessAnalysis);
  }
};
</script>

<style lang="scss" scoped>
.enface-image-wrapper {
  position: relative;
  height: 100%;
}
</style>
